export const HAS_DEFAULT_IMAGE_ANIMATION = false;
